import React from 'react';
import { ChannelOutput } from 'js/model/rainbow/content/ChannelOutput';

export const channelContext = React.createContext<ChannelOutput>(
  {} as ChannelOutput
);
